var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OpeningHours } from './opening-hours';
import { Period } from './period';
import { Menu } from './menu';
import { Pos } from './pos';
import { Brand } from './brand';
import { Category } from './category';
import { Data } from './data';
import { Location } from './location';
import { Printer } from "./printer";
import { Crm } from './crm';
var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    function Store() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Store";
        _this.features = [];
        return _this;
    }
    Object.defineProperty(Store.prototype, "sign", {
        get: function () {
            if (this.currency == null && this.currencySign == null)
                return "$";
            if (this.currencySign != null)
                return this.currencySign;
            var cur = this.currency.toLowerCase();
            var sign = "$";
            if ("cny" == cur) {
                sign = "¥";
            }
            else if ("inr" == cur) {
                sign = "₹";
            }
            else if ("myr" == cur) {
                sign = "RM";
            }
            else if ("sgd" == cur) {
                sign = "S$";
            }
            else {
                sign = "$";
            }
            return sign;
        },
        enumerable: true,
        configurable: true
    });
    Store.isOpeningHours = function (store, time) {
        var oh = store.openings;
        if (!oh)
            return true;
        var brand = store.brand;
        if (brand && brand.openings) {
            var holidays = brand.openings;
            oh.ph1 = holidays.holidays;
        }
        var openings = null;
        if (brand && brand.openings) {
            openings = brand.openings;
        }
        return OpeningHours.isTimeOpen(openings, oh, time);
    };
    Store.hasFeature = function (store, feature) {
        if (store.features) {
            return store.features.indexOf(feature) >= 0;
        }
        return false;
    };
    Store.prototype.hasFeature = function (feature) {
        if (this.features) {
            return this.features.indexOf(feature) >= 0;
        }
        return false;
    };
    Store.getPickUpInfo = function (store) {
        var addInfo = {};
        if (store && store.location && store.menu.settings && store.menu.settings.pickUpTimeLimit) {
            addInfo = {
                time: store.menu.settings.pickUpTimeLimit,
                store: store.name,
                branch: store.location.name
            };
        }
        return addInfo;
    };
    Store.isWholeDayOpen = function (store) {
        var previousEndTime;
        var isWholeDay = true;
        var periods = store.menu ? (store.menu.periods ? store.menu.periods : []) : [];
        if (periods.length <= 0) {
            return false;
        }
        periods.forEach(function (period, index) {
            if (previousEndTime && isWholeDay) {
                isWholeDay = period.start - previousEndTime === 60000;
            }
            previousEndTime = period.end;
        });
        return isWholeDay;
    };
    Store.prototype.toProperty = function (name, value) {
        switch (name) {
            case "brand":
                value = Data.toData(Brand, value);
                break;
            case "menu":
                value = Data.toData(Menu, value);
                break;
            case "categories":
                value = Data.toDataArray(Category, value);
                break;
            case "location":
                value = Data.toData(Location, value);
                break;
            case "pos":
                value = Data.toData(Pos, value);
                break;
            case "printers":
                value = Data.toDataArray(Printer, value);
                break;
            case "periods":
                value = Data.toDataArray(Period, value);
                break;
            case "openings":
            case "openings2":
                value = Data.toData(OpeningHours, value);
                break;
            case "crm":
                value = Data.toData(Crm, value);
                break;
            default:
                value = _super.prototype.toProperty.call(this, name, value);
                break;
        }
        return value;
    };
    return Store;
}(Data));
export { Store };
//# sourceMappingURL=store.js.map